import React from "react";
import {
    ProjectLockDialogShowerContext
} from "@/pages/takeoff/context/project-lock-dialog-shower/project-lock-dialog-shower-context-props.ts";

const useProjectLockDialogShower = () => {
    const context = React.useContext(ProjectLockDialogShowerContext);
    if (context === undefined) {
        throw new Error('useProjectLockDialogShower must be used within a ProjectLockDialogShowerProvider');
    }
    return context;
};

export default useProjectLockDialogShower;